import React from "react";
import building from "../../../assets/images/hero-building.svg";

// Ported from bimify-brand-nextjs components/landing/hero-outline.tsx. The centrelines were
// recovered there from the Figma export; keep them in sync if the illustration changes.
const SILHOUETTE =
	"M471.6 385.7 L315.3 383.2 L315.1 317.1 L2.2 332.1 L2.0 64.9 L146.7 2.0 L146.7 159.5 L472.1 79.9";
const GABLE_LEFT = "M146.7 2.0 L146.2 159.1";
const GABLE_RIGHT = "M146.7 2.0 L327.3 115.2";

/**
 * Landing-page hero: the building illustration with its purple outline traced on.
 * ponytail: CSS keyframes instead of GSAP; pathLength="1" so dash maths needs no getTotalLength.
 */
const HeroAnimation = () => (
	<div className="hero-animation">
		<img src={building} alt="" className="hero-animation__building" />
		<svg
			viewBox="0 0 482 406"
			fill="none"
			aria-hidden
			className="hero-animation__outline"
		>
			<g strokeWidth={4} strokeLinecap="round" strokeLinejoin="round">
				<path d={SILHOUETTE} pathLength="1" />
				<path d={GABLE_LEFT} pathLength="1" />
				<path d={GABLE_RIGHT} pathLength="1" />
			</g>
		</svg>
	</div>
);

export default HeroAnimation;
